"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _Button = require("../../../elements/button/Button");
var _quickViewErrorModule = _interopRequireDefault(require("./quick-view-error.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * @deprecated This component will be removed in version 24
 */var QuickViewError = function QuickViewError(_ref) {
  var handleRetryClick = _ref.handleRetryClick,
    pdpUrl = _ref.pdpUrl,
    isQuickAdd = _ref.isQuickAdd,
    customErrorMessage = _ref.customErrorMessage;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: _quickViewErrorModule.default.container,
    children: typeof customErrorMessage !== 'undefined' ? customErrorMessage : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        className: _quickViewErrorModule.default.info,
        children: "Unable to load ".concat(isQuickAdd ? 'options for this product' : 'Quick View', ".")
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
        className: _quickViewErrorModule.default.info,
        "data-testid": "instructions",
        children: ["Please", ' ', /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.UnderlinedButton, {
          onClick: handleRetryClick,
          children: "try again"
        }), ' ', "or go to the", ' ', pdpUrl ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.UnderlinedButton, {
          href: pdpUrl,
          children: "product page"
        }) : 'product page', "."]
      })]
    })
  });
};
/**
 * @deprecated This component will be removed in version 24
 */
var _default = exports.default = /*#__PURE__*/(0, _react.memo)(QuickViewError);